// extracted by mini-css-extract-plugin
module.exports = {"container":"paginate_container__1_mjp","button":"paginate_button__236XA","other":"paginate_other__32NRs"};